module.exports = __webpack_public_path__ + "img/12.4704a4eb.jpg";